'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentBitpayAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 85 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83.1,
          height: 57,
          rx: 5.3,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M77.8506 22.0429H74.1866L72.0553 31.1001H72.0591L71.7662 32.346C71.5617 32.4039 71.3582 32.4561 71.1562 32.497C70.7768 32.5736 70.3848 32.612 69.9802 32.612C69.5079 32.612 69.1369 32.544 68.8674 32.4075C68.5975 32.2714 68.4079 32.0799 68.2983 31.8327C68.1885 31.586 68.1466 31.2923 68.172 30.9513C68.1973 30.6109 68.2605 30.2449 68.3617 29.8529L69.4743 25.1524L70.2078 22.0357L70.208 22.0348H66.4648L64.7704 29.2654C64.5682 30.134 64.45 30.9602 64.4165 31.7434C64.3823 32.5269 64.5005 33.2211 64.7704 33.8253C65.0399 34.4301 65.4951 34.9072 66.1361 35.2561C66.7766 35.6048 67.6788 35.7797 68.842 35.7797C69.6514 35.7797 70.3509 35.7115 70.9412 35.5752C70.9651 35.5697 70.988 35.5639 71.0113 35.5581L71.0096 35.5648C70.8456 36.3108 70.5135 36.9158 69.9804 37.388C69.4467 37.8606 68.6549 38.0969 67.6049 38.0969C67.1567 38.0969 66.7494 38.07 66.3803 38.0184L65.6592 41.0833C66.147 41.1471 66.6877 41.18 67.2849 41.18C68.4007 41.18 69.3774 41.0512 70.2143 40.7944C71.0512 40.5374 71.7688 40.148 72.3679 39.6257C72.9668 39.1036 73.4673 38.4486 73.8695 37.6618C74.2714 36.8742 74.5955 35.9422 74.8418 34.8644L77.3771 24.0982C77.3739 24.0967 77.371 24.0956 77.368 24.0942L77.8506 22.0429Z",
          fill: "#002855"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M59.8786 25.1552C58.1701 25.1552 57.844 25.1552 57.1439 25.522C56.6469 25.7822 56.2355 26.1734 55.8743 26.6298C55.5127 27.0864 55.2294 27.6132 55.0242 28.2106C54.8184 28.8084 54.7159 29.4307 54.7159 30.078C54.7159 30.8747 54.8473 31.5058 55.1105 31.9703C55.3729 32.4352 55.8579 32.6673 56.5645 32.6673C56.9424 32.6673 57.2833 32.5928 57.5875 32.4433C57.8913 32.2939 58.216 32.0448 58.561 31.6963C58.5938 31.2817 58.6473 30.846 58.7213 30.3893C58.7951 29.9331 58.8889 29.51 58.9713 29.1278L59.8786 25.1552ZM62.4802 29.7792C62.2498 30.7255 62.1842 31.6756 62.2828 32.63C62.3816 33.5848 62.743 35.0474 63.0955 35.7796H59.5497C59.1165 35.0395 59.136 34.6927 59.054 34.46C58.5938 34.842 58.0844 35.1572 57.526 35.4061C56.9671 35.655 56.3427 35.7796 55.6525 35.7796C54.8309 35.7796 54.1283 35.6341 53.5453 35.344C52.9617 35.0536 52.4853 34.6635 52.1156 34.1738C51.7458 33.6844 51.4785 33.1117 51.3147 32.4559C51.1501 31.8003 51.0681 31.0989 51.0681 30.352C51.0681 29.2067 51.269 28.1278 51.672 27.1154C52.0744 26.103 52.6333 25.219 53.3481 24.4636C54.0627 23.7084 55.7878 22.043 58.6186 22.043C59.8419 22.043 61.4861 22.0428 64.3031 22.0428L62.4802 29.7792Z",
          fill: "#002855"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M41.0417 32.6205C41.3229 32.6875 41.6702 32.7208 42.084 32.7208C42.7291 32.7208 43.3161 32.5998 43.8458 32.3574C44.375 32.1153 44.8259 31.777 45.1981 31.3422C45.5703 30.9078 45.8594 30.3859 46.0665 29.7757C46.2731 29.1658 46.3767 28.4935 46.3767 27.758C46.3767 27.0397 46.2194 26.4295 45.9053 25.9283C45.5909 25.4269 45.0397 25.1605 44.2622 25.1573C43.7187 25.1552 42.816 25.1552 42.816 25.1552L41.0417 32.6205ZM50.0491 27.4822C50.0491 28.7023 49.8506 29.8177 49.4535 30.8284C49.0567 31.8397 48.5065 32.7127 47.8036 33.4476C47.1001 34.1832 46.2565 34.7554 45.2725 35.1647C44.2881 35.5739 43.2169 35.7787 42.059 35.7787C41.4965 35.7787 40.9339 35.7286 40.3718 35.6283L39.2551 40.165H35.5827L39.8456 22.0433C40.4657 22.0429 43.7465 22.0433 44.739 22.0433C45.6652 22.0433 46.4636 22.1854 47.1335 22.4693C47.8036 22.7537 48.3532 23.1421 48.7836 23.6348C49.2135 24.1279 49.5318 24.7045 49.7389 25.3642C49.9454 26.0247 50.0491 26.7304 50.0491 27.4822Z",
          fill: "#002855"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M33.329 32.6146C32.8569 32.6146 32.4857 32.5468 32.2164 32.4103C31.9463 32.2742 31.7567 32.0825 31.6473 31.8355C31.5374 31.5888 31.4956 31.2949 31.5208 30.9541C31.5461 30.6137 31.6093 30.2477 31.7105 29.8557L32.8233 25.1552H36.9961L37.7548 22.0385H33.5566L34.5176 18.0787L30.5977 18.692L28.1192 29.2681C27.917 30.1366 27.7988 30.963 27.7653 31.7461C27.7312 32.5297 27.8493 33.2237 28.1192 33.8281C28.3888 34.4329 28.8439 34.9098 29.485 35.2587C30.1254 35.6076 31.0276 35.7823 32.191 35.7823C33.0002 35.7823 33.6997 35.7141 34.2901 35.578C34.351 35.5639 34.4436 35.5413 34.5037 35.5266L35.2668 32.3022C35.0105 32.3905 34.7531 32.4497 34.505 32.4998C34.1257 32.5764 33.7337 32.6146 33.329 32.6146Z",
          fill: "#002855"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M23.9833 22.0349L20.7486 35.7823H24.4127L27.6475 22.0349H23.9833Z",
          fill: "#002855"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M28.027 20.4455L28.5889 18.0575H24.9248L24.3628 20.4455H28.027Z",
          fill: "#002855"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.6542 32.7137C13.2297 32.7137 13.7727 32.5726 14.2827 32.29C14.7925 32.0076 15.2329 31.6293 15.6031 31.1558C15.9731 30.6821 16.265 30.1462 16.479 29.548C16.6926 28.9499 16.7998 28.3266 16.7998 27.6784C16.7998 26.8808 16.668 26.2576 16.405 25.8091C16.1416 25.3602 15.5946 25.1552 14.8876 25.1552C14.657 25.1552 14.4186 25.1776 14.0484 25.2606C13.6782 25.344 13.3589 25.5165 13.0629 25.7822L11.454 32.6199C11.9298 32.7041 12.0946 32.7137 12.21 32.7137C12.3248 32.7137 12.473 32.7137 12.6542 32.7137ZM15.862 22.0451C16.6518 22.0451 17.3342 22.1865 17.9103 22.469C18.4859 22.7516 18.9629 23.1336 19.3415 23.6154C19.7197 24.0976 19.9993 24.6623 20.1804 25.3105C20.3613 25.9586 20.452 26.6566 20.452 27.4042C20.452 28.5509 20.2423 29.6352 19.8228 30.6572C19.4032 31.6792 18.8315 32.5683 18.1077 33.3244C17.3836 34.0808 16.5284 34.679 15.5412 35.119C14.5543 35.5592 13.4847 35.7797 12.3334 35.7797C12.1854 35.7797 11.9263 35.7753 11.5561 35.7672C11.1859 35.7586 10.7621 35.7213 10.2851 35.655C9.80789 35.5884 9.30202 35.4888 8.76762 35.3558C8.23266 35.2231 7.72697 35.0405 7.24998 34.8076L11.519 16.6858L15.344 16.0876L13.8327 22.5102C14.1615 22.3607 14.4717 22.2532 14.8011 22.1698C15.1299 22.0867 15.4835 22.0451 15.862 22.0451Z",
          fill: "#002855"
        }
      )
    ]
  }
);
const VpPaymentBitpayAsset = forwardRef(PaymentBitpayAsset);

export { VpPaymentBitpayAsset as default };
